import { useTranslation } from 'react-i18next';

export default function QuoteSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-secondary-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Image */}
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] md:aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Peaceful%20Penghu%20coastal%20scene%20at%20golden%20hour%20soft%20light%20blue%20ocean%20clear%20sky%20minimal%20composition%20serene%20atmosphere%20artistic%20landscape%20photography%20warm%20glow%20horizon%20calm%20waves%20natural%20beauty%20tranquil%20mood%20editorial%20style&width=800&height=1000&seq=quote-img-001&orientation=portrait"
                alt="Peaceful Penghu"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-800/20 to-transparent" />
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full lg:w-3/5 flex flex-col">
            {/* Label */}
            <span className="text-xs md:text-sm text-accent-500 font-medium tracking-widest uppercase mb-4">
              {t('quote.label')}
            </span>

            {/* Quote Title */}
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-[#0A2D5E] leading-tight mb-8">
              {t('quote.text').split('；')[0]}
              {t('quote.text').includes('；') && (
                <>
                  <span className="text-accent-400">；</span>
                  {t('quote.text').split('；')[1]}
                </>
              )}
            </h2>

            {/* Attribution */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-px bg-secondary-400" />
              <span className="text-sm font-medium text-foreground-500">
                {t('quote.attribution')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}